<template>
  <div class="mt-4 ml-3 d-flex justify-content-between pagination-container">
    <span :class="{'hidden': !showText}"
          class="pagination-info">Mostrando {{ startIndex }} al {{ endIndex }} de {{ total }} resultados</span>
    <ul class="pagination mr-3 d-flex flex-wrap">
      <li class="mr-2 rounded bg-light-gray" v-if="currentPage > (pageButtonCount - pageButtonOffset)">
        <a @click="goToPage(1)">
          <i class="fa fa-chevron-double-left"></i>
        </a>
      </li>

      <li class="mr-2  rounded bg-light-gray" v-if="currentPage > 1">
        <a @click="goToPage(currentPage - 1)">
          <i class="fa fa-chevron-left"></i>
        </a>
      </li>
     
      <li v-for="page in pages"
          :key="page"
          class="custom-border rounded border-top border-bottom">
        <a @click="goToPage(page)"
           :class="{ active: page === currentPage }">{{ page }}</a>
      </li>
     
      <li class="ml-2 rounded" v-if="currentPage < data.pageCount">
        <a @click="goToPage(currentPage + 1)"
           class="bg-light-gray">
          <i class="fa fa-chevron-right"></i>
        </a>
      </li>

      <li class="ml-2 rounded bg-light-gray">
        <a @click="goToLastPage()" v-if="currentPage < (data.pageCount - pageButtonOffset)">
          <i class="fa fa-chevron-double-right"></i>
        </a>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.pagination-info {
  text-align: left;
  font: Regular 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}
.pagination {
  cursor: pointer;
  font: Bold 14px/17px Lato;
}
.pagination > li > a {
  min-width: 33px;
  height: 34px;
  position: relative;
  float: left;
  text-align: center;
  line-height: 34px;

  letter-spacing: 0;
  color: #11291b;
  text-decoration: none;
}
.pagination > ul > li {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
}

.pagination > li a.active {
  background: #2db782 0% 0% no-repeat padding-box;
  color: white;
  border-radius: 4px;
}
.rounded {
  border-radius: 4px;
}

.custom-border {
  border: 1px solid #dee2e6!important;
}
</style>

<script>
export default {
  name: "Pagination",
  meta: {
    description: "Indica contenido relacionado en varias páginas.",
    slots: {
      default: {
        type: "component",
        valid: []
      }
    }
  },
  props: {
    showText: {
      type: Boolean,
      required: false,
      default: true
    },
    pageSize: {
      type: Number,
      required: false,
      default: null
    },
    data: {
      type: Object,
      default() {
        return {
          currentPage: 0,
          totalItemCount: 0,
          pageCount: 0,
          count: 0
        };
      },
      meta: {
        description: 'Establece la data relacionada al componente',
        example: '',
      } 
    }
  },
  data(){
    return {
      pageButtonCount: 5,
      pageButtonOffset: 2
    };
  },
  computed: {
    pageSizeComputed() {
      if (this.pageSize) return this.pageSize;

      return Math.ceil(this.data.totalItemCount / this.data.pageCount);
    },
    pages() {
      const pages = [];
      const offset = this.pageButtonOffset;
      let endAt = this.pageButtonCount;
      let startAt = 1;

      if (this.currentPage > 3 && this.data.pageCount > this.currentPage + offset) {
        endAt = this.currentPage + offset;
        startAt = this.currentPage - offset;
      } else if (this.currentPage > 3 && this.currentPage <= this.data.pageCount) {
        endAt = this.data.pageCount;
        startAt = this.data.pageCount - 4;
      }

      if (startAt < 0) startAt = 1;
   
      let qtyButtons = 0;

      if(this.data.pageCount <= endAt)
      {
        qtyButtons = this.data.pageCount;
      }
      else
      {
        qtyButtons = endAt;
      }

      for (let i = startAt; i <= qtyButtons; i++) {
        pages.push(i);
      }

      return pages;
    },
    total() {
      return this.data.totalItemCount;
    },
    startIndex() {
      let startIndex = this.pageSizeComputed * this.currentPage - this.pageSizeComputed;
     
      if (startIndex === 0) {
        startIndex = 1;
      }

      if (this.data.totalItemCount > 0 & this.currentPage > 1 && this.data.count < 5) {
       startIndex = this.data.totalItemCount - this.data.count;
      }
      if (this.currentPage > 1){
        startIndex = startIndex +1;
      }
      return startIndex;
    },
    endIndex() {
      let endIndex = this.startIndex;

      if(this.pageSizeComputed > this.data.count)
        endIndex += this.data.count;
      else
        endIndex += this.pageSizeComputed;

      return endIndex - 1;
    },
    currentPage() {
      return this.data.currentPage;
    }
  },
  methods: {
    goToPage(pageNumber) {
      if (pageNumber < 1 || pageNumber > this.data.pageCount) return;
      if (pageNumber !== this.currentPage) {       
        this.$emit("pagination-go-page", pageNumber);
      }
    },
    goToLastPage() {   
      if(this.currentPage == this.data.pageCount) return;
      
      this.$emit("pagination-go-page", this.data.pageCount);
    },
  }
};
</script>
